import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Links from '../component/Link'

/* Plan du site — second système de navigation (RGAA 12.1 / 12.3) */
function PlanDuSite() {
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
    document.title = 'Plan du site — Place des Victoires'
  }, [])

  const goToAnchor = (path, id) => {
    navigate(path)
    setTimeout(() => document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' }), 500)
  }

  const openContact = () => window.dispatchEvent(new CustomEvent('pdv:open-contact'))

  const linkCls = 'links text-[#cbbef0] hover:text-white underline-animation'
  const subCls = 'text-[#a99bd0] hover:text-white underline-animation bg-transparent text-left'

  return (
    <div className="container-pdv pt-36 pb-24 lg:pt-44">
      <span className="eyebrow">Navigation</span>
      <h1 className="mt-5 font-display font-extrabold leading-[1.05] text-[clamp(2rem,4.4vw,3.4rem)]">
        Plan du <span className="text-gradient">site</span>
      </h1>
      <p className="mt-5 text-lg text-[#b6a9d8] max-w-2xl">
        Retrouvez l'ensemble des pages et sections du site.
      </p>

      <div className="mt-12 grid gap-10 sm:grid-cols-2 lg:grid-cols-3">
        <section className="card-surface rounded-3xl p-7">
          <h2 className="font-display font-bold text-xl text-white">Accueil</h2>
          <ul className="mt-4 space-y-2.5">
            <li><Links to="/" className={linkCls}>Page d'accueil</Links></li>
            <li><button onClick={() => goToAnchor('/', 'Prestation')} className={subCls}>Nos prestations</button></li>
            <li><button onClick={() => goToAnchor('/', 'Partenaire')} className={subCls}>Ils nous font confiance</button></li>
            <li><button onClick={() => goToAnchor('/', 'Creation')} className={subCls}>Nos créations</button></li>
          </ul>
        </section>

        <section className="card-surface rounded-3xl p-7">
          <h2 className="font-display font-bold text-xl text-white">Qui sommes-nous&nbsp;?</h2>
          <ul className="mt-4 space-y-2.5">
            <li><Links to="/quisommenous" className={linkCls}>Le studio &amp; Creative Handicap</Links></li>
            <li><Links to="/quisommenous" className={linkCls}>La formation CIARA</Links></li>
            <li><Links to="/quisommenous" className={linkCls}>Nos valeurs &amp; nos équipes</Links></li>
          </ul>
        </section>

        <section className="card-surface rounded-3xl p-7">
          <h2 className="font-display font-bold text-xl text-white">Nos prestations</h2>
          <ul className="mt-4 space-y-2.5">
            <li><button onClick={() => goToAnchor('/prestations', 'multimedia')} className={subCls}>Création multimédia</button></li>
            <li><button onClick={() => goToAnchor('/prestations', 'modelisation')} className={subCls}>Modélisation 3D</button></li>
            <li><button onClick={() => goToAnchor('/prestations', 'accessibilité')} className={subCls}>Accessibilité &amp; FALC</button></li>
            <li><button onClick={() => goToAnchor('/prestations', 'sensibilisation')} className={subCls}>Sensibilisation handicap</button></li>
            <li><button onClick={() => goToAnchor('/prestations', 'formation')} className={subCls}>Formations</button></li>
          </ul>
        </section>

        <section className="card-surface rounded-3xl p-7">
          <h2 className="font-display font-bold text-xl text-white">Contact</h2>
          <ul className="mt-4 space-y-2.5">
            <li><button onClick={openContact} className={subCls}>Formulaire de contact</button></li>
            <li>
              <a href="mailto:contact@placedesvictoires.tech" className={linkCls}>
                contact@placedesvictoires.tech
              </a>
            </li>
          </ul>
        </section>
      </div>
    </div>
  )
}

export default PlanDuSite
